import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { PARKING_VOUCHERS_ACTIONS, PARKING_VOUCHERS_TYPES } from "./actions";
import {
  getParkingVoucherTemplate as APIgetParkingVoucherTemplate,
  getParkingVoucherTemplates as APIgetParkingVoucherTemplates,
  createParkingVoucherTemplate as APIcreateParkingVoucherTemplate,
  updateParkingVoucherTemplate as APIupdateParkingVoucherTemplate,
  deleteParkingVoucherTemplate as APIdeleteParkingVoucherTemplate
} from "../../services/api/parkingVoucherTemplates";
import { navigateTo } from "../navigation/saga";
import { parkingVouchersFilters } from "./selectors";

export function* watchParkingVouchersActions() {
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.LOAD_ALL_REQUEST, getParkingVouchers)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.LOAD_REQUEST, getParkingVoucher)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.CREATE_REQUEST, createParkingVoucher)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.UPDATE_REQUEST, updateParkingVoucher)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.DELETE_REQUEST, deleteParkingVoucher)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.CREATE_SUCCESS, getParkingVouchers)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.DELETE_SUCCESS, getParkingVouchers)
  ]);
  yield all([
    takeEvery(PARKING_VOUCHERS_TYPES.UPDATE_FILTERS, getParkingVouchers)
  ]);
}

function* getParkingVouchers(action) {
  try {
    const filters = yield select(parkingVouchersFilters);
    const parkingVouchers = yield call(APIgetParkingVoucherTemplates, filters);
    yield put(PARKING_VOUCHERS_ACTIONS.loadAllSuccess(parkingVouchers));
  } catch (e) {
    yield put(PARKING_VOUCHERS_ACTIONS.loadAllFailure(e));
  }
}

function* getParkingVoucher(action) {
  const { id } = action.payload;
  try {
    const parkingVoucher = yield call(APIgetParkingVoucherTemplate, id);
    yield put(PARKING_VOUCHERS_ACTIONS.loadSuccess(parkingVoucher));
  } catch (e) {
    yield put(PARKING_VOUCHERS_ACTIONS.loadFailure(e));
  }
}

function* createParkingVoucher(action) {
  const { values, redirect } = action.payload;
  try {
    const parkingVoucher = yield call(APIcreateParkingVoucherTemplate, values);
    yield put(PARKING_VOUCHERS_ACTIONS.createSuccess(parkingVoucher));
    if (redirect) {
      yield call(
        navigateTo,
        "/admin/events/" + values.eventId + "/vouchers/parking"
      );
    } else {
      yield call(
        navigateTo,
        "/admin/events/" + values.eventId + "/vouchers/parking/create"
      );
    }
  } catch (e) {
    yield put(PARKING_VOUCHERS_ACTIONS.createFailure(e));
  }
}

function* updateParkingVoucher(action) {
  const { id, values } = action.payload;
  try {
    const parkingVoucher = yield call(
      APIupdateParkingVoucherTemplate,
      id,
      values
    );
    yield put(PARKING_VOUCHERS_ACTIONS.updateSuccess(parkingVoucher));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/vouchers/parking"
    );
  } catch (e) {
    yield put(PARKING_VOUCHERS_ACTIONS.updateFailure(e));
  }
}

function* deleteParkingVoucher(action) {
  const { id } = action.payload;
  try {
    const parkingVoucher = yield call(APIdeleteParkingVoucherTemplate, id);
    yield put(PARKING_VOUCHERS_ACTIONS.deleteSuccess(parkingVoucher));
  } catch (e) {
    yield put(PARKING_VOUCHERS_ACTIONS.deleteFailure(e));
  }
}
